<template>
  <a-modal
    v-model:visible="visible"
    :title="`新建重定向`"
    @ok="() => {}"
    style="width: 800px;"
  >
    <div>
      <div>
        <div class="mb20">
          <div class="mb6"><span class="red">*</span>重定向自：</div>
          <div class="mb6" style="color: #999999;">
            此为您希望重定向的原始URL，设置后用户无法访问此URL
          </div>
          <div>
            <a-input
              class="w400"
              v-model:value="addParams.fromUrl"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="mb20">
          <div class="mb6"><span class="red">*</span>重定向至：</div>
          <div class="mb6" style="color: #999999;">
            将访问者转发到新URL
          </div>
          <div>
            <a-input
              class="w400"
              v-model:value="addParams.toUrl"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="mb20">
          <div class="mb6"><span class="red">*</span>场景：</div>
          <div>
            <a-input
              v-model:value="addParams.scene"
              style="width: 400px;"
              placeholder="请输入"
            />
          </div>
        </div>
        <div>
          <div class="mb6"><span class="red">*</span>状态码：</div>
          <div>
            <a-input
              v-model:value="addParams.statusCode"
              style="width: 400px;"
              placeholder="请输入"
            />
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="tar">
        <a-button type="default" @click="visibleChange(false)">取消</a-button>
        <a-button type="primary" @click="addListData">保存</a-button>
      </div>
    </template>
  </a-modal>
</template>
<script>
import { inject, toRefs, reactive } from 'vue'
export default {
  setup() {
    const state = reactive({})
    return {
      ...toRefs(state),
      ...toRefs(inject('initState'))
    }
  }
}
</script>
<style scoped>
.red {
  color: red;
}
</style>
